import(/* webpackMode: "eager" */ "/opt/build/repo/app/events/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["UpcomingEventsSection"] */ "/opt/build/repo/app/events/upcoming.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/opt/build/repo/node_modules/.pnpm/@apollo+client-react-streaming@0.12.3_@apollo+client@3.14.0_@types+react@19.2.7_graphql_c0c766c31ff4aebbf1d458a7a578c58f/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["Role"] */ "/opt/build/repo/node_modules/.pnpm/@ariakit+react@0.4.17_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/@ariakit/react/esm/index.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@next+third-parties@16.0.10_next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_re_851ce30b7d8be78d69a6d1bd9c8727cd/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@next+third-parties@16.0.10_next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_re_851ce30b7d8be78d69a6d1bd9c8727cd/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@next+third-parties@16.0.10_next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_re_851ce30b7d8be78d69a6d1bd9c8727cd/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.97.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.0.10_@babel+core@7.29.7_@opentelemetry+api@1.9.0_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.97.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/assets/icons/card-logo.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/button/button.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/cards/base/base.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/cards/base/CardLogo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/cards/voices/voices.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/fullBleedCta/fullBleedCta.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/grid/column/column.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/grid/context.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/link/link.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/list/list.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/list/list.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/components/search/result/global/globalSearchResult.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/heroAsset/heroAsset.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/modules/image/image.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/styles/truncate.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/ui/styles/spacing.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/v1/components/list/item/item.module.scss");
